import React, { createRef, useContext, useEffect, useRef, useState } from 'react'
import { checkDpSuccess, getCompanyType, getFileBase64, getFormErrorMessage, splitFileExtension, splitFileName } from '../../utility/service/tool-service';
import { Controller, set, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { FormInput } from '../../components/FormInput';
import { createCompaniesFilesList, queryCompaniesFilesList, updateCompaniesFilesList, deleteCompaniesFilesList } from '../../utility/service/companyfile-service';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NoInfo from '../../components/NoInfo';
import PrimeTableFooter from '../../components/PrimeTableFooter';
import { FormInputFile } from '../../components/FormInputFile';
import { AlertService } from '../../utility/service/alert-service';
import ImagePDFComponent from '../../components/ImagePDFComponent';
import { MessageContext,handleSuccessMessage } from '../../store/messageStore';
import { deleteMultipartFile, downloadMultipartFile, uploadMultipartFile } from '../../utility/service/api-file';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import { SystemLoading,checkLoading } from '../../store/loadingStore';
import PrimeDialog from '../../components/dialog/PrimeDialog';
import { queryCompanyList } from '../../utility/service/company-service';
import { handleFileDownloadRes } from '../../utility/service/api-base';
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import { useEditableFlag } from '../../hooks/useEditableFlag';

const CompanyFile = () => {

    const { t } = useTranslation();
    const [isLoading,setIsLoading] = useState(false);
    const [companyPlaceList,setCompanyPlaceList] = useState();
    const [rows,setRows] = useState([]);
    const refs = useRef([]);
    const [, loading] = useContext(SystemLoading);
    const [, dispatch] = useContext(MessageContext); //訊息視窗 
    const [addDialog,setAddDialog] = useState(false);
    // 更新文件名稱
    const [modifyCateNameDialog,setModifyCateNameDialog] = useState(false);
    const [nowCompanySeq,setNowCompanySeq] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    // 刪除文件
    const [delDialog, setDelDialog] = useState(false);
    const [delObj,setDelObj] = useState({});
    const isEditable = useEditableFlag('F10401'); // Get editable status for F10401 function


    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
        
        },
        //錯誤驗證時機
        mode: "all"
      });


    const onSubmit = (data) => {
        axios_queryCompaniesFilesList({companySeq:data.companySeq});
    }
  
    const checkKeyDown = (e) => {
          if (e.key === 'Enter') e.preventDefault();
    }

    const btnReadMore = ()=>{

    }

    const createItem = ()=>{
        setAddDialog(true);
    }

    const confirmAdd=()=>{
        let reqBody = {
            companySeq:getValues("companySeq"),
            cateCode:'others',
            cateName: getValues("cateName")
        }
        
        createCompaniesFilesList(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    let data = res?.data?.RespBody;
                    if(data){
                        setAddDialog(false);
                        setValue("cateName","");
                        clearErrors(["cateName"]);
                        handleSuccessMessage(dispatch, t('button.create') + ' ' + t('message.success'));
                        axios_queryCompaniesFilesList({companySeq:data?.companySeq});
                    }
                  

                    
                }
            })
    }

    const handleFileChange = (e,ref,index,rowData)=>{ //每次開啟選擇檔案觸發onChange事件
        
        if(e.target.files[0]){ 
           
            if(e.target.files[0].size >=20000000 ){ //大於20MB 
                AlertService.ok('Error', "Size over 20MB");
                ref.value = null;
                setRows((pre)=>{
                    pre[index].fileExtension = "";
                    pre[index].fileName = "";
                    pre[index].provingDataPath ="";
                    pre[index].previewUrl = ""
                    pre[index].zoomSrc = ""
                    return [ ...pre ]
                })
            }else{
                let fileExtension = splitFileExtension(e.target.files[0]?.name);
                getFileBase64(e.target.files[0])
                .then((result)=>{
                 
                    if(rowData?.companiesFileId===null){
                        let reqBody = {
                            companySeq:rowData?.companiesSeq,
                            cateCode:rowData?.cateCode,
                            cateName:rowData?.cateName
                        }
                        createCompaniesFilesList(reqBody)
                            .then((res)=>{
                                if(checkDpSuccess(res)){
                                    let data = res?.data?.RespBody
                                    setRows((pre)=>{
                                        pre[index].companiesFileId = data.companiesFileId;
                                        return [ ...pre ]
                                    })
                                    axios_uploadProvingData(index,e.target.files[0],splitFileName(e.target.files[0]?.name),fileExtension,e.target.files[0],rowData,data.companiesFileId)

                                    
                                }
                            })
                    }else{
                        if(rowData?.companiesFileId!==null){
                            let reqBody = {
                                companiesFileId:rowData?.companiesFileId,
                                companySeq:rowData?.companiesSeq,
                                cateCode:rowData?.cateCode,
                                cateName:rowData?.cateName
                            }
                            updateCompaniesFilesList(reqBody)
                                .then((res)=>{
                                    if(checkDpSuccess(res)){
                                        axios_uploadProvingData(index,e.target.files[0],splitFileName(e.target.files[0]?.name),fileExtension,e.target.files[0],rowData,rowData?.companiesFileId)
                                    }
                                })
                        }

                    }

                })
              
            }
           
        }
    }

    

    const handleDeleteImg = (e,ref,index,fileId)=>{ //刪除圖片
        checkLoading(loading);
        deleteMultipartFile({fileId})
            .then((res)=>{
                if(checkDpSuccess(res)){
                    setRows((pre)=>{
                        pre[index].companiesFileId = null;
                        pre[index].fileName = "";
                        pre[index].fileExtension = "";
                        pre[index].filePath ="";
                        pre[index].filePathSml = "";
                        pre[index].previewUrl = "";
                        return [ ...pre ]
                    })
                    handleSuccessMessage(dispatch, t('button.delete') + ' ' + t('message.success'));
                    axios_queryCompaniesFilesList({companySeq:getValues("companySeq")});
                    
                }else{
                    AlertService.ok(res?.data?.ResHeader?.rtnMsg);
                }
            }).finally(fin=>{ 
                checkLoading(loading, false);
            })
          
      
     
    }

    const axios_uploadProvingData = (period,provingData,fileName,fileExtension,file,rowData,companiesFileId)=>{
        
        checkLoading(loading);
        const formData = new FormData();
        
        //call 共用上傳API API好了開啟這裡
        formData.append("fileName",fileName);
        formData.append("filePath","companies_files/");
        formData.append("fileCateCode",rowData?.cateCode);
        formData.append("refId",companiesFileId);
        formData.append("attachFile",file);
        formData.append("fileExtension",fileExtension);
        // 加上 companySeq
        formData.append("companySeq",getValues("companySeq"));
        uploadMultipartFile(formData)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    // let zoomSrc = fileExtension==='pdf'||fileExtension==='zip'?"": URL.createObjectURL(file) ;
                    let zoomSrc = URL.createObjectURL(file) ;
                    setRows((pre)=>{
                        pre[period].fileExtension = fileExtension;
                        pre[period].fileName = fileName;
                        pre[period].previewUrl = URL.createObjectURL(file);//縮圖
                        pre[period].zoomSrc = zoomSrc;//放大圖
                        pre[period].fileId = res.data?.RespBody.fileId
                        pre[period].filePath = URL.createObjectURL(file);
                        pre[period].filePathSml = URL.createObjectURL(file);
                        pre[period].fileInfo = {
                            type:fileExtension,
                            name:fileName
                        }
                        return [ ...pre ]
                    })
                    handleSuccessMessage(dispatch, t('button.upload') + ' ' + t('message.success'));
                    axios_queryCompaniesFilesList({companySeq:rowData?.companiesSeq});

                }
            }).finally(fin=>{ 
                checkLoading(loading, false);
                document.getElementById(`fileName_${period}`).value = null;
            })
    }

    // 刪除文件
    const axios_deleteCompaniesFilesList = ()=>{
        checkLoading(loading);
        let reqBody = {
            companiesFileId: delObj.companiesFileId
          }
        deleteCompaniesFilesList(reqBody).finally(fin=>{
            axios_queryCompaniesFilesList({companySeq:nowCompanySeq});
            checkLoading(loading, false);
            setDelDialog(false);
        })
    }

    // 更新文件名稱
    const handleConfirmModifyCateName = () => {
        checkLoading(loading, true);

        const updatedCateName = getValues("cateName");
        const reqBody = {
            companiesFileId: selectedRow?.companiesFileId,
            companySeq: selectedRow?.companiesSeq,
            cateCode: selectedRow?.cateCode,
            cateName: updatedCateName
        };

        updateCompaniesFilesList(reqBody)
            .finally(() => { 
                axios_queryCompaniesFilesList({ companySeq: nowCompanySeq });
                setModifyCateNameDialog(false);
                checkLoading(loading, false);
                setValue("cateName", "");
            });
    };

    const bodyTemplate = (data, options) => {
       return (
         <div className="grid">
           <div className={`${data?.fileExtension ? "col-6" : "col-12"}`}>
             <FormInputFile
               register={register}
               errors={errors}
               fileInputRef={refs.current[options.rowIndex]}
               id={`fileName_${options.rowIndex}`}
               name={`fileName_${options.rowIndex}`}
               limitSize="20MB"
               wrapperClass="in-table-cell"
               acceptFileType={`.jpg,.png${data.cateCode === "others" ? ",.pdf,.zip" : ""}`}
               disabled={!isEditable}
               fileChange={(e) => {
                 handleFileChange(e, refs.current[options.rowIndex], options.rowIndex, data);
               }}
             />
           </div>
           {data?.fileExtension && (
             <div className="col-6">
               {data?.fileExtension !== "zip" && (
                 <ImagePDFComponent
                   imgHeight="100"
                   imgWidth="100"
                   disabled={!isEditable}
                   file={data.fileInfo}
                   zoomSrc={data?.zoomSrc}
                   previewUrl={data?.fileExtension === "pdf" ? data?.filePath : data?.filePathSml}
                   deleteImg={(e) => {
                     handleDeleteImg(e, refs, options.rowIndex, data?.fileId);
                   }}
                 />
               )}

               {data?.fileExtension !== "pdf" &&
                 data?.fileExtension !== "zip" &&
                 data?.fileExtension !== "" &&
                 data?.fileExtension !== null && (
                   <>
                     {data?.fileName}
                     {data?.fileName !== "" ? "." : ""}
                     {data?.fileExtension}
                   </>
                 )}

               {data?.fileExtension === "zip" && (
                 <div className="flex flex-wrap lg:flex-nowrap align-items-center">
                   <label>
                     {data?.fileName}
                     {data?.fileName !== "" ? "." : ""}
                     {data?.fileExtension}
                   </label>
                   <Button
                     type="button"
                     icon="pi pi-trash"
                     tooltip={t("button.delete")}
                     tooltipOptions={{ position: "top" }}
                     className="p-button-icon-only"
                     rounded
                     text
                     severity="danger"
                     disabled={!isEditable}
                     onClick={(e) => {
                       handleDeleteImg(e, refs, options.rowIndex, data?.fileId);
                     }}
                   ></Button>

                   <Button
                     rounded
                     text
                     severity="secondary"
                     className="p-button-icon-only"
                     type="button"
                     tooltip={t("button.download")}
                     tooltipOptions={{ position: "top" }}
                     onClick={() => {
                       downloadItem(data, options.rowIndex + 1);
                     }}
                   >
                     <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
                   </Button>
                 </div>
               )}
             </div>
           )}
         </div>
       );
    };

    const cateNameBodyTemplate = (data, options) => {
        return (
          <>
            {data?.cateCode === "others" && (
              <div className="flex-nowrap align-items-center">
                <Button
                  type="button"
                  tooltip={t("button.edit")}
                  tooltipOptions={{ position: "top" }}
                  className="p-button-icon-only"
                  rounded
                  text
                  severity="secondary"
                  disabled={!isEditable}
                  onClick={(e) => {
                    setModifyCateNameDialog(true);
                    setSelectedRow(data);
                    setValue("cateName", data?.cateName);
                  }}
                >
                  <FontAwesomeIcon icon="fa-solid fa-pen" />
                </Button>
                <Button
                  type="button"
                  tooltip={t("button.delete")}
                  tooltipOptions={{ position: "top" }}
                  className="p-button-icon-only"
                  rounded
                  text
                  severity="secondary"
                  disabled={!isEditable}
                  onClick={(e) => {
                    setDelObj(data);
                    setDelDialog(true);
                  }}
                >
                  <FontAwesomeIcon icon="fa-solid fa-trash" />
                </Button>
              </div>
            )}
          </>
        );
    }

    useEffect(()=>{
        axios_queryCompanyList();
    },[])



   //組織邊界廠商清單
  const axios_queryCompanyList = ()=>{
    setIsLoading(true);
    queryCompanyList()
      .then((res)=>{
        if(checkDpSuccess(res)){
          let data = res.data.RespBody.companyList
          setCompanyPlaceList(data);
          if(getCompanyType()==='A'){
            setValue("companySeq",data[0].companySeq);
            trigger("companySeq");
            axios_queryCompaniesFilesList({companySeq:data[0].companySeq})
            setNowCompanySeq(data[0].companySeq)
          }

        }

      }).finally(() => {
        setIsLoading(false)
      })
  }

  const axios_queryCompaniesFilesList = (reqBody)=>{
    checkLoading(loading);
    queryCompaniesFilesList(reqBody)
        .then((res)=>{
            if(checkDpSuccess(res)){
                let data = res?.data?.RespBody?.companiesFileList;
                setRows(data);

                if (data) {
                    const newRows = data?.map(item => {
                        let previewUrl = '';
                        let zoomSrc = '';
                        let fileInfo = null;
        
                        if (item?.fileExtension !== 'zip' && item?.fileExtension) {
                            previewUrl = item?.filePathSml;
                            zoomSrc = item?.fileExtension === 'pdf' ? '' : item?.filePath;
        
                            fileInfo = {
                                name: item?.fileName,
                                type: item?.fileExtension,
                            };
                        }
        
                        return {
                            ...item,
                            previewUrl,
                            zoomSrc,
                            fileInfo,
                        };
                    });
                    setRows(newRows)
                }
                if (!refs.current.length) {
                    refs.current = Array(data?.length).fill(null).map((_, i) => refs.current[i] || createRef());
                  }
                
            }
        }).finally((fin)=>{checkLoading(loading,false);})
  }

    //zip 才能點下載
    const downloadItem = (rowData, period) => {
        checkLoading(loading);
        downloadMultipartFile({
            fileId:rowData?.fileId
        }).then((res)=>{
            if(res?.status===200){
                handleFileDownloadRes(res, `${rowData.fileName}.zip`)
            }else{
                AlertService.ok(res?.data?.ResHeader?.rtnCode,res?.data?.ResHeader?.rtnMsg)
            }
        }).finally((fin)=>{
            checkLoading(loading,false);
        })
    }

  return (
    <>
    <div className="p-card bg-gray">
        <div className="p-card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grid">
                <div className="col-12 lg:col-12">
            <label
              htmlFor="placeName"
              className="form-label required">
              {t('organName')}
            </label>
            <Controller
              name="companySeq"
              control={control}
              rules={{ required: { value: true, message: t('validation.required') } }}
              render={({ field, fieldState }) => (
                <Dropdown
                  loading={isLoading.toString()==='true'?1:0}
                  filter
                  disabled={getCompanyType()==='A'}
                  appendTo={"self"}
                  optionLabel="companyName"
                  optionValue="companySeq"
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  name="companySeq"
                  control={control}
                  options={companyPlaceList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                    axios_queryCompaniesFilesList({companySeq:event.value})
                    setNowCompanySeq(event.value)
                  }}
                />
              )}
            />
            {getFormErrorMessage(errors, "companySeq")}
          </div>
                </div>
    

        <div className="col-12 gap-2 flex-all-center">
            <Button disabled={!isValid} type="submit" label={t("button.query")} />
            <Button disabled={!isValid || !isEditable} outlined type="button" onClick={() => { createItem();  }} label={t("button.create")} />
        </div>
            </form>
        </div>
    </div>
   
    <div className="p-card">
        <div className="p-card-body">
            <DataTable
                    stripedRows
                    className="white-data-table hover-highlight no-shadow"
                    tableStyle={{ minWidth: '55rem' }}
                    footer={rows?.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={false} btnReadMore={btnReadMore} />}
                    emptyMessage={<NoInfo panel="table"/>}
                    value={rows}
                >
                  
                    <Column field="cateName" header={t('fileName')}></Column>
                    <Column field="updateUser" header={t('update_user')}></Column>
                    <Column field="updateDateTime" header={t('update_date')}></Column>
                    <Column header={`${t('attached_picture')}/${t('attachments')}`} body={bodyTemplate} ></Column>
                    <Column header={t('action_type')} body={cateNameBodyTemplate}></Column>

                </DataTable>

        </div>
    </div>

        <PrimeDialog
            size='sm'
            visible={addDialog}
            onClose={() => {
                setAddDialog(false);
                clearErrors(["cateName"])
                trigger("companySeq");
            }}
            disabledConfirm={!isValid}
            onConfirm={() => { confirmAdd(); }}
            title={t('button.create')}
            bodyTemplate={
            <FormInput
                register={register}
                errors={errors}
                id="cateName"
                type="text"
                labelText={t('fileName')}
                labelClass="control-label required"
                rules={{required:{value:addDialog===true?true:false,message:t('validation.required')}}}
              />  
            }
        />

        {/*編輯文件名稱*/}
        <PrimeDialog
            size='sm'
            visible={modifyCateNameDialog}
            onClose={() => {
                setModifyCateNameDialog(false);
            }}
            disabledConfirm={!isValid}
            onConfirm={() => handleConfirmModifyCateName()}
            title={t('button.edit')}
            bodyTemplate={
            <FormInput
                register={register}
                errors={errors}
                id="cateName"
                type="text"
                labelText={t('fileName')}
                labelClass="control-label required"
              />  
            }
        />

        {/*刪除文件*/}
        <PrimeConfirmDialog
            visible={delDialog}
            onClose={() => { setDelDialog(false) }}
            onConfirm={() => { axios_deleteCompaniesFilesList(); }}
            title={t('button.delete')}
            bodyTemplate={<>
            <div className="form-label">{t('fileName')}: {delObj?.cateName}</div>

            </>}
          />


    </>
  )
}

export default CompanyFile